import React from "react";
// Styles
import styled from "styled-components";
// State
import PropTypes from "prop-types";
// Components
import { Element } from "react-scroll";
import { Col, Container, Row } from "react-bootstrap";
import Title from "./Title";
import { experienceList } from "../config";

// #region styled-components
const StyledAboutMe = styled.section`
  p {
    font-size: 1.25rem;
  }
  .img {
    width: 18rem;
    height: 18rem;
  }
  .title {
    color: ${({ theme }) => theme.name === "light" ? "#000" : "var(--primary-green)"};
  }
  .text-color {
    color: ${({ theme }) => theme.name === "light" ? "#000" : "var(--primary-green)"};
  }

  .experience-list ul {
    display: flex;
    flex-direction: row;
    gap: 2rem;
    list-style: none;
    padding: 0;
    margin: auto;
  }
  .experience-list li {
    padding-left: 2rem;
    border-left: 2px solid ${({ theme }) => theme.name === "light" ? "#000" : "var(--primary-green)"};
  }
  .experience-list li:first-child {
    border-left: none;
    padding-left: 0;
  }
  .experience-list li {
    font-size: 1.25rem;
  }

  @media (max-width: 767.98px) {
    .experience-list ul {
      flex-direction: column;
      gap: 0.75rem;
    }

    .experience-list li,
    .experience-list li:first-child {
      border-left: none;
      padding-left: 0;
    }
  }
`;
// #endregion

// #region component
const propTypes = {
  avatar_url: PropTypes.string.isRequired,
  bio: PropTypes.string,
  moreInfo: PropTypes.string,
  experienceList: PropTypes.arrayOf(PropTypes.string),
};
const AboutMe = ({ avatar_url, bio, moreInfo }) => {
  return (
    <Element name={"About"} id="about">
      <StyledAboutMe className="section">
        <Container>
          <Container className="d-flex justify-content-center">
            <Title size={"h2"} text={"About Me"} color={"green"} />
          </Container>
          <Row className="align-items-center mt-5">
            <Col className="d-flex flex-column col-md-6 col-12 mb-4 text-center">
              <Container>
                {bio && <p className="text-font-semibold text-color">{bio}</p>}
                {moreInfo && <p className="text-font-semibold text-color">{moreInfo}</p>}
              </Container>
            </Col>
            <Col className="d-md-block col-md-6 col-12 text-center">
              <img
                src={avatar_url}
                alt="GitHub Avatar"
                loading="lazy"
                className="mx-auto rounded-circle border border-primary-subtle"
                style={{ width: "15rem", height: "15rem" }}
              />
            </Col>
          </Row>
          <Row className="d-flex justify-content-center mt-5 text-font-semibold text-color">
            <Col className="d-flex flex-column experience-list text-center mt-5">
              <ul>
                {experienceList.map((experience, index) => (
                  <li key={index}>
                    {experience}
                  </li>
                ))}
              </ul>
            </Col>
          </Row>
        </Container>
      </StyledAboutMe>
    </Element>
  );
};

AboutMe.propTypes = propTypes;
// #endregion

export default AboutMe;
